import { Container, Sprite } from '../../../odie';

import { BubblesBlockProps } from '../../defs/block';
import { config } from '../../defs/config';
import { blockPositionView } from '../../util/blockTools';
import { CageBlockView } from './CageBlockView';

// constants
//-------------------------------------------------------------------------
const manifest = {
  bubble: 'bubbles/block.bubbles.single.png',
};

interface Bubble {
  sprite: Sprite;
  tick: number;
  direction: number;
}

/*
    bubbles block view
*/
export class BubblesBlockView extends Container {
  public bubbles: Bubble[] = [];
  private _isAnimatingOut = false;

  // init
  //-------------------------------------------------------------------------
  constructor(props: BubblesBlockProps) {
    // create base view
    super();
    const offset = Math.random();
    for (let index = 0; index < props.amount; index++) {
      const sprite = Sprite.from(manifest.bubble);
      sprite.anchorX = sprite.anchorY = 0.5;
      sprite.scaleX = sprite.scaleY = 0.3 + ((index * 0.869) % 1) * 0.3;
      this.addChild(sprite);
      this.bubbles.push({
        sprite,
        tick: ((index * 0.793 + offset) % 1) * Math.PI * 2,
        direction: index % 2 === 0 ? 1 : -1,
      });
    }
    this.refreshBubbles();
    blockPositionView(this, props);
    this.y += 6;
  }

  public refreshBubbles() {
    const size = config.tile.size;
    this.bubbles.forEach((bubble) => {
      const sprite = bubble.sprite;
      const direction = bubble.direction;
      const bubbleSize = sprite.width * sprite.scaleX;
      const radius = (size - bubbleSize * 0.75) * 0.5;
      const baseAngle = bubble.tick * Math.PI * 2;
      const speed = 0.5 / sprite.scaleX;
      const ax = baseAngle * speed * 0.075;
      const ay = baseAngle * speed * 0.075;
      const bx = baseAngle * speed * 0.1;
      const by = baseAngle * speed * 0.05;
      sprite.x = Math.cos(ax) * Math.cos(bx) * radius * direction;
      sprite.y = Math.sin(ay) * Math.cos(by) * radius * direction;
    });
  }

  public get isAnimatingOut(): boolean {
    return this._isAnimatingOut;
  }

  public set isAnimatingOut(value: boolean) {
    this._isAnimatingOut = value;
  }

  public static assets(): string[] {
    return [...Object.values(manifest), ...CageBlockView.assets()];
  }
}
